/**
 * RadioButton Color System
 *
 * TODO: Move to centralized theme/colors file in future MR
 * These colors are currently hardcoded across RMC components
 */
export const RADIO_BUTTON_COLORS = {
  neutral: {
    border: {
      default: '#E8ECF0',
      selected: '#016AD4'
    },
    background: {
      default: '#FFFFFF',
      selected: '#E6F0FB'
    },
    indicator: {
      default: '#D1D9E0',
      selected: '#016AD4'
    },
    innerDot: '#FFFFFF'
  },
  warning: {
    border: {
      default: '#E8ECF0',
      selected: '#F59E0B'
    },
    background: {
      default: '#FFFFFF',
      selected: '#FEF7ED'
    },
    indicator: {
      default: '#D1D9E0',
      selected: '#F59E0B'
    },
    innerDot: '#FFFFFF'
  }
} as const

/**
 * RadioButton Layout Constants
 */
export const RADIO_BUTTON_LAYOUT = {
  container: {
    padding: '12px 16px',
    borderRadius: '8px',
    borderWidth: '1px'
  },
  indicator: {
    size: '16px',
    innerSize: '6px'
  },
  text: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#29333D'
  },
  gap: {
    horizontal: '16px',
    vertical: '8px',
    internal: '8px' // gap between indicator and label
  }
} as const
